import moment from "moment";
import { FormValidationRule } from "../../forms/types";
import {
    parseDateModifier as dateRuleParser,
    parseDateFormat
} from "../../forms/helper";

const maxDateRangeRule: FormValidationRule = (c, v) => {
    const rule = c.field_boi_max_date_range_rule;
    let valid = true;
    let message = "";

    if (
        rule &&
        ((!c.inputs && v) ||
            (c.inputs && v[c.inputs[0].id] && v[c.inputs[1].id]))
    ) {
        const dateFormat = c.dateFormat || "dmy";
        const startDate = c.inputs
            ? moment(v[c.inputs[0].id], "YYYY-MM-DD")
            : moment().startOf("day");
        const endDate = moment(c.inputs ? v[c.inputs[1].id] : v, "YYYY-MM-DD");
        const duration = moment.duration(dateRuleParser(rule));
        const maxEndDate = startDate
            .clone()
            .add(duration)
            .add(c.inputs ? -1 : 0, "days");

        if (endDate.isAfter(maxEndDate)) {
            valid = false;
            message = `Please select a date before ${maxEndDate
                .add(1, "days")
                .format(parseDateFormat(dateFormat).toUpperCase())}.`;
        }
    }

    return [valid, message];
};

export default maxDateRangeRule;
